import Vue from 'vue'
import ProvincesProducts from "./ProvincesProducts";


/*import {BootstrapVue} from 'bootstrap-vue'
Vue.use(BootstrapVue)*/
import {
    ButtonGroupPlugin,
    ButtonPlugin,
    ButtonToolbarPlugin,
    CardPlugin,
    DropdownPlugin,
    FormInputPlugin,
    FormSelectPlugin,
    ModalPlugin,
    TabsPlugin
} from 'bootstrap-vue'
import Dialogs from "@/plugins/dialogs";

Vue.use(TabsPlugin)

Vue.use(CardPlugin)

Vue.use(FormSelectPlugin)

Vue.use(FormInputPlugin)

Vue.use(ButtonToolbarPlugin)

Vue.use(DropdownPlugin)

Vue.use(ButtonPlugin)

Vue.use(ButtonGroupPlugin)

Vue.use(ModalPlugin)

Vue.use(Dialogs);


const fields = document.querySelectorAll('.provinces-products-widget');

[...fields].forEach(el => {
    new Vue({
        name: 'provinces-products-widget',
        el,
        components: {
            ProvincesProducts
        },
        methods: {
            setValue(value) {
                this.$refs.input.value = JSON.stringify(value)
            }
        }
    })
})

